













































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import BaseMixin from '@/components/mixins/base';
import DxValidationGroup from 'devextreme-vue/validation-group';
import { CreateChartModel } from './types';
import DxTextBox from 'devextreme-vue/text-box';
import { DxRequiredRule, DxValidator, DxStringLengthRule } from 'devextreme-vue/validator';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxColorBox from 'devextreme-vue/color-box';
import { apiService, cubejsService, customerService } from '@/container';
import DxList from 'devextreme-vue/list';
import DxButton from 'devextreme-vue/button';
import ChartRender from '@/components/charts/ChartRender.vue';
import { QueryBuilder } from '@cubejs-client/vue';
import { DxSelectBox } from 'devextreme-vue/select-box';
import FilterBuilder from './filter-builder.vue';
import ChartCreateFields from './chart-create-fields.vue';
import { ChartType } from './types';
import DxCheckBox from 'devextreme-vue/check-box';
import { isArray, isEmpty, isEqual, isNil, merge } from 'lodash';
import { getDefaultChartConfig, IChartConfig } from '@/components/charts/resultSetTransform';
import { TCubeMeasure } from '@cubejs-client/core';
import { tryTranslateCaption } from '@/components/charts/resultSetTransform/chartSteps';

@Component({
	components: {
		DxSelectBox,
		ChartRender,
		DxValidationGroup,
		DxTextBox,
		DxValidator,
		DxStringLengthRule,
		DxRequiredRule,
		DxDropDownBox,
		DxList,
		DxButton,
		DxColorBox,
		QueryBuilder,
		FilterBuilder,
		ChartCreateFields,
		DxCheckBox
	}
})
export default class ChartCreate extends BaseMixin {
	model: CreateChartModel = { name: null };
	cubejsApi: any = null;
	chart: any = {};
	query: any = {};
	internalChartType: string | null = null;
	selectedChartType: string | null = null;
	showSaveButton = false;
	isCustomizationpanelOpened = true;
	chartConfig: IChartConfig | null = getDefaultChartConfig();
	groupedByWeek = false;
	isPercentage = false;
	vizState: any = null;

	onConfigUpdate(newConfig) {
		if (!isEqual(this.chartConfig, newConfig))
			this.chartConfig = newConfig;
	}

	async created(): Promise<void> {
		var customer = customerService.getCustomer();
		if (customer != null) {
			const cube = await cubejsService.cubejsApi(customer);
			this.cubejsApi = cube;

			if (this.$route.query.idChart != undefined) {
				this.chart = await apiService.get('charts', this.$route.query.idChart.toString());
				this.query = JSON.parse(this.chart.query);
				this.model.name = this.chart.name;
				this.groupedByWeek = this.chart.groupingByWeek;
				this.internalChartType = this.chart.type;

				let configFromDb = JSON.parse(this.chart.additionalConfig ?? null);
				if (isNil(configFromDb))
					configFromDb = {
						isPercentage: this.internalChartType === 'pie',
						isStacked: false
					};
				this.chartConfig = configFromDb;
			} else
				this.internalChartType = this.chartTypes[0];
			this.selectedChartType = this.internalChartType;
		}

		this.assurePercentageOptionIsPresent();
	}

	/*
		THIS HAS BEEN DISABLED CAUSE WE HAVE SET HEURISTICS TO FALSE; IN CASE YOU ENABLE HEURISTICS AGAIN, ENABLE THIS PLEASE
		When changing chart type, cubeJs was changing autonomosly
		the granulrity of the time dimension into undefined
		causing troubles.. This was happening only for pie and table chart
		This code, attempts to solve the issue if present
	solveGranularityIssueIfNeccessary() {
		this.$watch(() => this.vizState, (val, oldVal) => {
			const isCurrentTimeDimensionDefined = isTimeDimensionDefined(val);
			if (!isCurrentTimeDimensionDefined)
				return;

			const isOldGranularityDefined = isGranularityDefined(oldVal);
			const isCurrentGranularityDefined = isGranularityDefined(val);
			if (!isCurrentGranularityDefined && isOldGranularityDefined) {
				const newVal = merge(val, {
					query: {
						timeDimensions: [{
							granularity: oldVal.query.timeDimensions[0].granularity
						}]
					}
				});
				// Setting fixed query into query prop, so that query builder can fix itself
				this.query = newVal.query;
			}

			function isGranularityDefined(vizState) {
				const isTimeDimensionsDefined = isTimeDimensionDefined(vizState);
				const isGranularityDefined = isTimeDimensionsDefined
					&& !isNil(vizState.query.timeDimensions[0].granularity)
					&& !isEmpty(vizState.query.timeDimensions[0].granularity);
				return isGranularityDefined;
			}

			function isTimeDimensionDefined(vizState) {
				return !isNil(vizState) && !isNil(vizState.query)
					&& !isNil(vizState.query.timeDimensions) && isArray(vizState.query.timeDimensions)
					&& vizState.query.timeDimensions.length > 0;
			}
		}, { deep: true });
	}
	*/

	chartTypes = Object.values(ChartType)
		.map(value => value as string)
		.sort();

	get isModelValid(): boolean {
		return this.model.name !== null && this.isNameValid;
	}

	groupByGranularity(granularityName) {
		this.groupedByWeek = (granularityName === 'week') ? true : false;
	}

	setShowSaveButton(value: boolean): boolean {
		this.showSaveButton = value;
		return value;
	}

	readonly maxNameLength: number = 100;
	isNameValid = true;

	loading = false;
	selectedItemKeys = [];

	onChangeChartTypeDropDownBoxValue({ value }: { value: string }, updateChartType: (chartType: string) => void): void {

		updateChartType(value);
		this.selectedChartType = value;

		//Set pie for showing percentage by default
		this.assurePercentageOptionIsPresent();

		//if (value == this.chartTypes[0])
		(this.$refs['first'] as any).$children[0].load();
	}

	assurePercentageOptionIsPresent() {
		if(!_.isNil(this.chartConfig) && isNil(this.chartConfig.isPercentage))
			this.$set(this.chartConfig, 'isPercentage', this.selectedChartType === 'pie');
		else if (this.internalChartType === 'pie' && !_.isNil(this.chartConfig) && !isNil(this.chartConfig.isPercentage) && !this.chartConfig?.isPercentage)
			this.chartConfig.isPercentage = true;
	}

	async onSaveClick(): Promise<void> {
		const query = (this.$refs['first'] as any).$children[0].query;
		const idDashboard = this.$route.query.idDashboard;
		if (this.$route.query.idChart == undefined) {
			const a = _.cloneDeep(this.chartConfig);
			// delete (a || {}).version;
			const result = await apiService.post('charts', 'create', {
				name: this.model.name,
				type: this.selectedChartType,
				query: query,
				idCustomer: customerService.getCustomer(),
				groupingByWeek: this.groupedByWeek,
				additionalConfig: a
			});
			await apiService.post('dashboards', `${idDashboard}/addChart`, { idChart: result.id });
		} else {
			const a = _.cloneDeep(this.chartConfig);
			// delete (a || {}).version;
			await apiService.post('charts', `${this.$route.query.idChart}/update`, {
				name: this.model.name,
				type: this.selectedChartType,
				query: query,
				groupingByWeek: this.groupedByWeek,
				additionalConfig: a
			});
		}

		this.$router.push({
			name: 'home',
			query: { idDashboard }
		});
	}

	onCancelClick() {
		const idDashboard = this.$route.query.idDashboard;
		this.$router.push({
			name: 'home',
			query: { idDashboard }
		});
	}

	onCustomizeClicked() {
		this.isCustomizationpanelOpened = !this.isCustomizationpanelOpened;
	}

	async addNewQuery(): Promise<void> {
		return;
	}

	onAddNewQuery() {
		this.addNewQuery();
	}

	get isColorsDefined() {
		return this.selectedChartType !== 'table'
			&& !_.isNil(this.chartConfig)
			&& !_.isNil(this.chartConfig.colors) && _.isArray(this.chartConfig.colors)
			&& this.chartConfig.colors.length > 0;
	}

	get canShowDonutCheckbox() {
		return !_.isNil(this.chartConfig) && !_.isNil(this.chartConfig.isDonut);
	}

	get canShowStackedCheckbox() {
		return !_.isNil(this.chartConfig) && !_.isNil(this.chartConfig.isStacked);
	}

	get isPie() {
		return this.selectedChartType == 'pie';
	}

	get isBar() {
		return this.selectedChartType == 'bar';
	}

	get canShowPercentage() {
		return !_.isNil(this.chartConfig)
			&& (
				this.selectedChartType == 'pie'
				|| (this.selectedChartType == 'bar' && !_.isNil(this.chartConfig) && !_.isNil(this.chartConfig.isStacked) && this.chartConfig.isStacked)
			);
	}


	// DO NOT REMOVE UNTIL THE REWORK OF THE COMPONENT
	onMeasureUpdates(measures: TCubeMeasure[]) {
		if (!isNil(this.chartConfig)) {
			if (Array.isArray(measures)) {
				if (isNil(this.chartConfig.measures))
					this.$set(this.chartConfig, 'measures', [...measures]);
				else if (!isEqual(this.chartConfig.measures, measures))
					this.chartConfig.measures = [...measures];
			}
			else {
				this.$set(this.chartConfig, 'measures', []);
			}
		}
	}
	// DO NOT REMOVE UNTIL THE REWORK OF THE COMPONENT
	onDimensionsUpdate(dimensions: any[]) {
		if (!isNil(this.chartConfig)) {
			if (Array.isArray(dimensions)) {
				if (isNil(this.chartConfig.measures))
					this.$set(this.chartConfig, 'selectedDimensions', [...dimensions]);
				else if (!isEqual(this.chartConfig.selectedDimensions, dimensions))
					this.chartConfig.selectedDimensions = [...dimensions];
			}
			else {
				this.$set(this.chartConfig, 'selectedDimensions', []);
			}
		}
	}

	convertCaptionIfNeeded(legendItem) {
		return tryTranslateCaption(legendItem.localeValue || legendItem.value, this.$t);
	}

}
